<template>
    <div class="battery view">
      <div>
        <span class="battery-title">Battery Cells</span>
  
        <div class="segments-grid">
          <div 
            class="battery-segment"
            v-for="segmentIndex in 12"
            :key="segmentIndex"
          >
            <table class="battery-table">
              <tbody>
                <tr>
                    <td class="segment-border">
                <tr v-for="row in 3" :key="row" >
                  <td 
                    v-for="col in 4" 
                    :key="col"
                    class="battery-cell"
                  >
                    <Battery 
                      @click="selectBattery(((segmentIndex - 1) * 12) + ((row - 1) * 4) + col)"
                      :batteryTemp="mainStore.getters.main(`Cell_Temperature_${((segmentIndex - 1) * 12) + ((row - 1) * 4) + col}`)" 
                      :batteryVoltage="mainStore.getters.main(`Cell_Voltage_${((segmentIndex - 1) * 12) + ((row - 1) * 4) + col}`)" 
                      :batteryId="((segmentIndex - 1) * 12) + ((row - 1) * 4) + col" 
                    />
                  </td>
                </tr>
            </td>
            </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  
      <!-- Battery statisztikák -->
      <div class="battery-stats">
        <div class="selected-battery">
          <span class="selected-battery-title">Selected battery cell (#{{ selectedBatteryId }})</span>
          <span class="s-battery-stat">Temperature: {{ mainStore.getters.main(`Cell_Temperature_${selectedBatteryId}`) }}℃</span>
          <span class="s-battery-stat">Voltage: {{ mainStore.getters.main(`Cell_Voltage_${selectedBatteryId}`) }}V</span>
        </div>
        <div class="selected-battery">
          <span class="selected-battery-title">General battery info</span>
          <span class="s-battery-stat">Avg temperature: {{ getAvgTemp }}℃</span>
          <span class="s-battery-stat">Avg voltage: {{ getAvgVoltage }}V</span>
        </div>
      </div>
    </div>
  </template>
  

<script setup>
import { mainStore } from '@/utils/telemetryData';
import Battery from '@/components/Battery.vue';
import { computed, ref } from 'vue';

let selectedBatteryId = ref(1);

const selectBattery = (id) => {
    selectedBatteryId.value = id;
}

const getAvgTemp = computed(()=>{
    let sum = 0;
    for(let i = 1; i < 145; i++){
        //console.log(mainStore.getters.main(`Cell_Temperature_${selectedBatteryId.value}`))
        sum += mainStore.getters.main(`Cell_Temperature_${selectedBatteryId.value}`)
        //console.log(sum)
    }
    //console.log(sum)
    return sum / 144;
})

const getAvgVoltage = computed(()=>{
    return 0;
})
</script>